import { UserAvatar, UserAvatarRef, BulkGetUserAvatarsRequest, BulkGetUserAvatarsResponse } from 'pbts/c1/api/assets/v1/user_avatars'
import { UserAvatarServiceClient } from 'pbts/c1/api/assets/v1/user_avatars.client'
import { UserServiceClient } from 'pbts/c1/api/user/v1/user.client'
import { createMultiGetApi, MultiGetOpts } from './lib/createMultiGetApi'
import { createMutationApi } from './lib/createMutationApi'

export const setUserAvatarApi = createMutationApi(
    UserServiceClient,
    'setUserAvatar',
)

export const setUserAvatarSelfApi = createMutationApi(
    UserServiceClient,
    'setUserAvatarSelf',
)

const multiGetOpts: MultiGetOpts<UserAvatarRef, BulkGetUserAvatarsRequest, BulkGetUserAvatarsResponse, UserAvatar> = {
    buildRequest: (refs: UserAvatarRef[]) => ({
        userAvatars: refs,
    }),
    transformResponse: (res: BulkGetUserAvatarsResponse) => {
        return res.list
    },
    refExtractor: (item: UserAvatar) => {
        if (!item.userAvatar) {
            throw new Error('Response must include userAvatar field')
        }
        return item.userAvatar
    },
    maxBatchSize: 100,
    tag: UserAvatarRef.typeName,
    watchInserts: true,
}

export const getUserAvatarApi = createMultiGetApi(
    UserAvatarServiceClient,
    'bulkGetUserAvatars',
    multiGetOpts,
)
